export default {
  name: "Footer",
  setup() {
    function toContact() {
      window.open("https://beian.miit.gov.cn/");
    }
    //回到顶部
    function toTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
    return {
      toTop,
      toContact
    };
  }
};